<template>
  <history-card-layout v-on="$listeners">
    {{ context.description || context.rpc }}
    <template slot="action">
      <dropdown-menu
        :items="contextMenu"
        item-key-text="text"
        :itemKeyValue="'id'"
        @input="handleContext($event, context, true)"
      >
        <template v-slot:activator="{ on }">
          <slot name="activator" :on="on">
            <v-btn
              data-test-parameter-general-menu
              slot="activator"
              v-on="on"
              class="table-button-context"
              icon
              color="#686868"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </slot>
        </template>
      </dropdown-menu>
    </template>
    <template slot="list">
      <v-list>
        <v-hover
          v-slot:default="{ hover }"
          v-for="item in listArguments"
          :key="item.id"
        >
          <v-list-item>
            <v-list-item-icon> </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                :data-test-value="item.description || item.argument"
              >
                {{ item.description || item.argument }}
              </v-list-item-title>

              <v-list-item-subtitle>
                Property type: {{ item.type }} Default:
                {{ item.defaultValue || 'n/a' }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <dropdown-menu
                :items="contextMenu"
                item-key-text="text"
                :itemKeyValue="'id'"
                @input="handleContext($event, item)"
                :hover="hover"
              >
                <template v-slot:activator="{ on }">
                  <slot name="activator" :on="on">
                    <v-btn
                      :data-test-paramater-ctx-menu="
                        item.description || item.argument
                      "
                      slot="activator"
                      v-show="hover || $vuetify.breakpoint.mdAndDown"
                      v-on="on"
                      class="table-button-context"
                      icon
                      color="#686868"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </slot>
                </template>
              </dropdown-menu>
            </v-list-item-action>
          </v-list-item>
        </v-hover>
        <!--            <infinite-loading @infinite="loadHistoryItem">-->
        <!--              <div slot="spinner">-->
        <!--                <v-progress-circular-->
        <!--                  class="mt-2"-->
        <!--                  size="25"-->
        <!--                  width="2"-->
        <!--                  indeterminate-->
        <!--                  color="primary"-->
        <!--                ></v-progress-circular>-->
        <!--              </div>-->
        <!--              <div slot="no-more"></div>-->
        <!--              <div slot="no-results">No history found</div>-->
        <!--            </infinite-loading>-->
        <v-list-item data-test-parameter="addNew" @click="addNewParameter">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Add new parameter
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </history-card-layout>
</template>
<script>
import DropdownMenu from '@/components/DropdownMenu';
import HistoryCardLayout from '@/components/history-card/HistoryCardLayout';
import { computed } from '@vue/composition-api';
import useCommonModal from '@/compositions/useCommonModal';
import useSchemaControlActions from '@/api/schemas/useSchemaControlActions';

export default {
  name: 'ControlsParameters',
  components: {
    HistoryCardLayout,
    DropdownMenu
  },
  props: {
    context: {
      type: [String, Object],
      default: ''
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    typeAction: {
      type: String,
      default: 'controls'
    },
    object: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const modalComposition = useCommonModal();
    const schemaControlActions = useSchemaControlActions();

    const contextMenu = [
      {
        id: 'edit',
        text: 'Edit',
        icon: 'mdi-pencil',
        _enabled: true
      },
      {
        id: 'delete',
        text: 'Delete',
        icon: 'mdi-delete',
        _enabled: true
      },
      {
        id: 'copy-uuid',
        text: 'Copy UUID',
        icon: 'mdi-image-filter-none',
        _enabled: false
      }
    ];
    const schemaControls = computed(() => {
      return props.object?.schemaControls || [];
    });

    const editSchemaControlParameter = targetEntity => {
      modalComposition.modal.show({
        component: () => import('@/components/app-entity/modals/AppDialog.vue'),
        bind: {
          nameModal: 'EditSchemaControlArgument'
        },
        slots: {
          default: {
            component: () =>
              import(
                '@/components/app-entity/modals/EditSchemaControlArgument.vue'
              ),
            bind: {
              entity: targetEntity,
              rpcName: props.context.rpc
            },
            on: {
              'update-table'() {},
              close() {
                modalComposition.modal.hide('EditSchemaControlArgument');
              },
              save() {
                // entity.lazyQuery.restart();
              }
            }
          }
        }
      });
    };

    const handleContext = (e, item, isClose) => {
      switch (e.id) {
        case 'edit': {
          editSchemaControlParameter(item);
          break;
        }
        case 'delete': {
          schemaControlActions.deleteSchemaControl(item);
          if (isClose) {
            emit('close-history');
          }
        }
      }
    };

    const listArguments = computed(() => {
      const listArguments = [];

      schemaControls.value.forEach(item => {
        if (item.rpc !== item.argument) {
          listArguments.push(item);
        }
      });

      return listArguments.filter(
        itemInner => itemInner.rpc === props.context.rpc
      );
    });

    const addNewParameter = () => {
      editSchemaControlParameter();
    };

    return {
      listArguments,
      schemaControls,
      contextMenu,
      handleContext,
      addNewParameter
    };
  }
};
</script>
